import { useFormContext } from 'react-hook-form';

import type { QSetReviewTaskDetailsFormInput } from '../../schemas';

export const useQSetReviewTaskFormContext = useFormContext<QSetReviewTaskDetailsFormInput>;
